import { userConstants } from './../constants/user.constants';

const initialState = {};

export function ColenderFundSource(state = initialState, action) {
  switch (action.type) {
    case userConstants.HANDLECOLENDERFUND_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.HANDLECOLENDERFUND_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.HANDLECOLENDERFUND_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}